module.exports = __webpack_public_path__ + "img/pick5.1241016a.png";